import { render, staticRenderFns } from "./MembersBoard.vue?vue&type=template&id=470feba4&"
import script from "./MembersBoard.vue?vue&type=script&lang=js&"
export * from "./MembersBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports